import { useTranslation } from "react-i18next";
import "../../../styles/UserAuthPage.css";
import { useState } from "react";
import { EyeIcon, EyeOffIcon } from "../../icons/EyeIcon";

function FormInputField({
  isSignIn,
  signInForm,
  signUpForm,
  handleSignInChange,
  handleSignUpChange,
  isLoading,
}) {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      {/* SIGN UP — extra fields */}
      {!isSignIn && (
        <>
          <div className="authPage__field authPage__field--animated">
            <label className="authPage__label">{t("auth.fields.fullName")}</label>
            <input
              type="text"
              name="fullName"
              value={signUpForm.fullName}
              onChange={handleSignUpChange}
              className="authPage__input"
              placeholder={t("auth.fields.fullName")}
              required
              disabled={isLoading}
            />
          </div>

          <div className="authPage__field authPage__field--animated">
            <label className="authPage__label">{t("auth.fields.occupation")}</label>
            <input
              type="text"
              name="occupation"
              value={signUpForm.occupation}
              onChange={handleSignUpChange}
              className="authPage__input"
              placeholder={t("auth.fields.occupation")}
              required
              disabled={isLoading}
            />
          </div>

          <div className="authPage__field authPage__field--animated">
            <label className="authPage__label">{t("auth.fields.state")}</label>
            <input
              type="text"
              name="state"
              value={signUpForm.state}
              onChange={handleSignUpChange}
              className="authPage__input"
              placeholder={t("auth.fields.state")}
              required
              disabled={isLoading}
            />
          </div>

          <div className="authPage__field authPage__field--animated">
            <label className="authPage__label">{t("auth.fields.lga")}</label>
            <input
              type="text"
              name="lga"
              value={signUpForm.lga}
              onChange={handleSignUpChange}
              className="authPage__input"
              placeholder={t("auth.fields.lga")}
              required
              disabled={isLoading}
            />
          </div>
        </>
      )}

      {/* EMAIL — shared by both modes */}
      <div className="authPage__field">
        <label className="authPage__label">{t("auth.fields.email")}</label>
        <input
          type="email"
          name="email"
          value={isSignIn ? signInForm.email : signUpForm.email}
          onChange={isSignIn ? handleSignInChange : handleSignUpChange}
          className="authPage__input"
          placeholder={t("auth.fields.email")}
          autoComplete={isSignIn ? "username" : "email"}
          required
          disabled={isLoading}
        />
      </div>

      {/* PASSWORD */}
      <div className="authPage__field">
        <label className="authPage__label">{t("auth.fields.password")}</label>
        <div className="authPage__inputWrapper">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={isSignIn ? signInForm.password : signUpForm.password}
            onChange={isSignIn ? handleSignInChange : handleSignUpChange}
            className="authPage__input"
            placeholder={t("auth.fields.password")}
            autoComplete={isSignIn ? "current-password" : "new-password"}
            required
            disabled={isLoading}
          />

          <button
            type="button"
            className="authPage__passwordToggle"
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <EyeOffIcon /> : <EyeIcon />}
          </button>
        </div>
      </div>

      {/* CONFIRM PASSWORD — only shown on sign-up */}
      {!isSignIn && (
        <div className="authPage__field authPage__field--animated">
          <label className="authPage__label">{t("auth.fields.confirmPassword")}</label>
          <input
            type={showPassword ? "text" : "password"}
            name="confirmPassword"
            value={signUpForm.confirmPassword}
            onChange={handleSignUpChange}
            className="authPage__input"
            placeholder={t("auth.fields.confirmPassword")}
            autoComplete="new-password"
            required
            disabled={isLoading}
          />
        </div>
      )}

      {/* SIGN IN EXTRAS: remember me + forgot password */}
      {isSignIn && (
        <div className="authPage__row authPage__row--animated">
          <label className="authPage__remember">
            <input type="checkbox" disabled={isLoading} />
            <span>Keep me signed in</span>
          </label>

          <button type="button" className="authPage__forgot" disabled={isLoading}>
            Reset Password
          </button>
        </div>
      )}
    </>
  );
}

export default FormInputField;
